/* eslint-disable react/prop-types */
import { darken } from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES } from "../../utils/constants";
import CustomerTableStatic from "components/CustomerTableStatic";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
const ALLVALUE = { ma: "ALL", ten: "Tất cả", id: "ALL" };
function GiayChungNhan() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [tableData, setTableData] = useState([]);
  const axiosPrivateInstance = useAxiosPrivate();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [cloneDataAll, setCloneDataALL] = useState([]);
  const setAlert = useSetRecoilState(AlertState);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramsFetchData, setParamsFetchData] = useState({
    loaivanban: ALLVALUE.id,
    // tinhtrang: ALLVALUE.id,
  });

  // Lấy toàn bộ dữ liệu theo năm, tỉnh, huyện, loại doanh nghiêp, cấp quản lý
  const fetchData = async ({}, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        loaivanban: 20,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.VANBAN, {
        params: body,
      });
      setTableData(response.data?.vanban);
      setRowCount(response.data?.totalRecord);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(paramsFetchData, pagination);
  }, [paramsFetchData, pagination]);

  useEffect(() => {
    const fetchDataCloneAll = async () => {
      try {
        let body = {
          loaivanban: 20,
        };
        const response = await axiosPrivateInstance.get(API_ROUTES.VANBAN, {
          params: body,
        });
        const validatedData = validateObjectDuan(response.data?.vanban);
        setCloneDataALL(validatedData);
      } catch (error) {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        console.log(error);
        return;
      }
    };
    fetchDataCloneAll();
  }, []);

  const validateObjectDuan = (rawData) => {
    const dataFiltered = rawData?.map((item) => {
      let dataEachItem = { ...item };
      if (item?.ngaybanhanh) {
        const value = item?.ngaybanhanh;
        dataEachItem["ngaybanhanh_format"] =
          value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
      }
      return { ...dataEachItem };
    });
    return dataFiltered;
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "sovanban",
        header: "Số văn bản",
        size: 150,
      },
      {
        accessorKey: "ngaybanhanh",
        header: "Ngày ban hành",
        size: 200,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value && dayjs(value)?.isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : "";
        },
      },
      {
        accessorKey: "trichyeu",
        header: "Nội dung",
      },
      {
        accessorKey: "nguoiky",
        header: "Người ký",
        size: 150,
      },
      {
        accessorKey: "coquanbanhanh",
        header: "Cơ quan ban hành",
        size: 200,
      },
      {
        accessorKey: "tinhtrang_ten",
        header: "Tình trạng",
        size: 150,
      },
    ],
    []
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <CustomerTableStatic
          columns={columns}
          data={tableData}
          allData={cloneDataAll}
          isUsingAllData={true}
          isLoading={isLoading}
          isError={isError}
          setPagination={setPagination}
          pagination={pagination}
          isRefetching={isRefetching}
          tableHeaders={[
            "Số văn bản",
            "Ngày ban hành",
            "Nội dung",
            "Người ký",
            "Cơ quan ban hành",
            "Tình trạng",
          ]}
          tableKeyValues={[
            "sovanban",
            "ngaybanhanh_format",
            "trichyeu",
            "nguoiky",
            "coquanbanhanh",
            "tinhtrang_ten",
          ]}
          filename={"GiayChungNhan1048"}
          titleTable={"Giấy chứng nhận sản phẩm OCOP"}
          colWidths={[5, 10, 15, 25, 15, 20, 10]}
          widthPercentPDF={[10, 10, 25, 15, 20, 15]}
          count={rowCount}
          orientaitionPage={"landscape"}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GiayChungNhan;
